import { Author } from '@/models/Report';

export interface PropType {
  authors: Author[];
  year: number;
  venue: string | null;
  maxAuthors?: number;
  title: string;
  corpusId: number | string;
  citationCount: number;
}

export const PaperMetadataString = (props: PropType): string => {
  const {
    title,
    authors: allAuthors,
    year,
    venue,
    maxAuthors = 6,
    corpusId,
    citationCount,
  } = props;
  const authors = allAuthors.slice(0, maxAuthors);
  const truncated = allAuthors.length > maxAuthors;

  let cleanVenue = '';
  if (venue) {
    cleanVenue = venue
      .replace(/&amp;/g, '&')
      .replace(/&nbsp;/g, ' ')
      .trim();
    cleanVenue = ` ${cleanVenue} • `;
  }

  return `<a target='_blank' href="https://www.semanticscholar.org/p/${corpusId}"><b>${title}</b></a><br />
  ${authors
    .map((author, index) => {
      return `<a key="${
        author.authorId
      }" target='_blank' href="https://www.semanticscholar.org/author/${
        author.authorId
      }">${author.name}</a>${index < authors.length - 1 ? ', ' : ''}`;
    })
    .join('')}${truncated ? ' et al' : ''}<br />
    ${year} • ${cleanVenue} ${
    citationCount > 0 ? ` ${citationCount.toLocaleString()} citations` : ''
  }`;
};
